import { NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }   from '@angular/forms';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { NglModule} from 'ng-lightning';

import{ ModalModule } from '../../../../common/component/modal/modal.module';

import { SelectDlgComponent } from './select-dlg.component';

@NgModule({
  imports: [
    CommonModule
    ,FormsModule
    ,DropDownsModule
    ,ModalModule
    ,NglModule
  ],
  declarations: [SelectDlgComponent],
  exports: [SelectDlgComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]

})
export class SelectDlgModule { }
